import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { Icon } from '@iconify/react'
import styles from './styles'
import { track } from '@amplitude/analytics-browser'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, {
  MessageBoxType,
  MessageBoxVariant,
} from 'src/model/message-box'
import ContainerMediaGalery from 'src/container/image-gallery'
import { useDispatch } from 'react-redux'
import URL from 'src/api/url'
import { headerBackgroundCss } from 'src/utils/default-header-background'

const HeaderSettingsImage = ({
  classes,
  background,
  primaryColor,
  previewType,
  onThemeSettingsChange,
}) => {
  const dispatch = useDispatch()

  const handleLearnMore = () => {
    if (window.Intercom) {
      window.Intercom('showArticle', '14723337')
    }
  }

  // Open media gallery modal
  const handleAddImage = () => {
    track('media_gallery_in_editor_clicked')

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: `
            <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
              <Icon icon="ic:round-add-a-photo" color="#00AB55" width="24" height="24" />
              <Typography style="margin-left: 8; color: #002E47; fontWeight: 600; fontSize: 16;">
                Media Gallery
              </Typography>
            </div>
          `,
          component: (
            <ContainerMediaGalery
              onOk={items => {
                onThemeSettingsChange('background', items[0].url)
                dispatch(messageBoxHideAction('message-box-1'))
              }}
              setImageURL={() => {}}
            />
          ),
          variant: MessageBoxVariant.DRAGGABLE,
          maxHeight: '640px',
        }),
      ),
    )
  }

  return (
    <div className={classes.imageContent}>
      <div className={classes.imageContainer}>
        <Typography className={classes.imageHeader}>Header image</Typography>
      </div>
      <div
        className={classes.background}
        style={{
          // The Default preset's image shows as the page draws it: in the
          // primary color.
          background: headerBackgroundCss(background || '', 0.3, primaryColor),
          // Apply specific dimensions for type 2 (Hero)
          ...(previewType === 2 && {
            height: '220px',
            width: '282px',
            alignSelf: 'flex-start', // Override stretch to allow specific width
          }),
        }}
      >
        <div className={classes.button} onClick={handleAddImage}>
          <Typography className={classes.buttonText}>Change image</Typography>
        </div>
      </div>
      <div className={classes.infoRow}>
        <Typography className={classes.imageText}>
          Recommended: 2400 × 800px (3:1 aspect ratio) · Max 6 MB · Keep key
          content centered, edges may crop on smaller screens.
        </Typography>
        <Typography
          className={classes.learnMore}
          onClick={handleLearnMore}
        >
          Learn more →
        </Typography>
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsImage)
